import React, { useRef, useState, useEffect } from "react";
import { Tooltip } from "antd";

interface TruncateWithTooltipProps {
    children: string;
    className?: string;
    style?: React.CSSProperties;
    maxWidth?: number | string;
}

const TruncateWithTooltip: React.FC<TruncateWithTooltipProps> = ({
    children,
    className = "",
    style = {},
    maxWidth = 140, // default max width for sidebar items
}) => {
    const textRef = useRef<HTMLDivElement>(null);
    const [truncated, setTruncated] = useState(false);

    useEffect(() => {
        const el = textRef.current;
        if (el) {
            setTruncated(el.scrollWidth > el.clientWidth);
        }
    }, [children, maxWidth]);

    return (
        <Tooltip title={truncated ? children : ""} placement="right" mouseEnterDelay={0.2} classNames={{ root: "custom-tooltip" }}>
            <div
                ref={textRef}
                className={className}
                style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth,
                    ...style,
                }}
            >
                {children}
            </div>
        </Tooltip>
    );
};

export default TruncateWithTooltip; 